import { type CaseReducerActions, type SliceCaseReducers } from '@reduxjs/toolkit';
import { type AppDispatch } from '../../_flux/Store';
import { actions as fahrzeugsucheFluxSetActions } from '../../_flux/slices/Fahrzeugsuche';
import { type FluxSetModuleActions, type FluxStoreModuleContent } from '../../_flux/types';
import { type Modules } from '../../modules/_definition/types';
import checkUndefinedOrNull from './checkUndefinedOrNull';

export default function getFluxFunctionsFromStore(module: Modules.Fahrzeugsuche, dispatch: AppDispatch): FluxSetModuleActions {
    const slices: Record<Modules.Fahrzeugsuche, CaseReducerActions<SliceCaseReducers<FluxStoreModuleContent>, Modules>> = {
        fahrzeugsuche: fahrzeugsucheFluxSetActions,
    };

    return {
        setViewOptions: function (payload) {
            if (!checkUndefinedOrNull(slices?.[module]?.setViewOptions)) {
                dispatch(slices?.[module]?.setViewOptions(payload));
            }
        },
    };
}
